<template>
  <div>
    <el-backtop>
      <div class="gotop"></div>
    </el-backtop>
    <div class="banner">
      <a href="javascript:void(0)" @click="gotoJiameng"><img class="img" :src="zixun" />咨询加盟</a>
    </div>
    <div :class="{ 'product-serve': true, 'fadeInUp': product }" id="product">
      <div>
        <h2>产品介绍</h2>
        <!-- <div class="small-text">PRODUCTS CENTER</div> -->
      </div>
    </div>
    <div class="jiaodai" id="jiaodai">
      <div :class="{ 'introduct': true, 'fadeInLeft': jiaodai_animation }">
        <div class="commit-tit">
          <h3>汽车充电交流终端</h3>
          <!-- <div class="small-text">DIGITAL MANAGEMENT PLATFORM</div> -->
        </div>
        <div class="text1">
          产品体积小、外观精致、安装便捷。采用自助方式操作，适用于各种需要交流充电的停车场所。用户可以自主完成充电、付费等操作，为电动汽车提供安全、可
靠、稳定的充电服务。
        </div>
        <p class="text2">
          <img class="img gou" :src="gou" />多形态颜值终端
        </p>
        <p class="text3">
          精细化服务态度，从颜值到质量严格把关，基于运营商个性化需求自动适配充电终端颜值形态。
        </p>
      </div>
      <div :class="{ 'img-parent': true, 'fadeInRight': jiaodai_animation }">
        <img class="img" :src="gl" />
      </div>
    </div>

    <div class="strip">
      <div class="shangji">
        <div :class="{ 'commit-tit': true, 'fadeInUp': shangjiTitle }" id="shangjiTitle">
          <h3>小场景大商机</h3>
        </div>
        <div :class="{ 'shangji-content': true }" id="shangjiContent">
          <ul>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[0]"></td>
                </tr>
                <tr>
                  <td>住宅小区</td>
                </tr>
                <tr>
                  <td>服务于本小区车辆的周边车辆
                    以及来访车辆</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[1]"></td>
                </tr>
                <tr>
                  <td>办公大楼与写字楼</td>
                </tr>
                <tr>
                  <td>为上班族提供工作日充电选项
                    尤其适合那些无法在家充电的
                    车主</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[2]"></td>
                </tr>
                <tr>
                  <td>购物中心与商业综合体</td>
                </tr>
                <tr>
                  <td>购物或就餐的同时，可以在停 车场内充电，方便消费者长时 间停留</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[3]"></td>
                </tr>
                <tr>
                  <td>工业园区与研发中心</td>
                </tr>
                <tr>
                  <td>为企业员工提供工作日充电选项，推动可持续出行实践</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[4]"></td>
                </tr>
                <tr>
                  <td>政府与公共设施</td>
                </tr>
                <tr>
                  <td>如图书馆、市政厅等地点，为 公共服务访问者提供便利</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[5]"></td>
                </tr>
                <tr>
                  <td>体育场馆与娱乐场所</td>
                </tr>
                <tr>
                  <td>观看比赛或演出的观众，可以
                    在享受娱乐活动的同时为爱车
                    充电</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[6]"></td>
                </tr>
                <tr>
                  <td>旅游景区与休闲公园</td>
                </tr>
                <tr>
                  <td>游客在游览结束后发现车辆已 经充满电，方便继续下一段旅 程</td>
                </tr>
              </table>
            </li>
            <li>
              <table>
                <tr>
                  <td> <img class="img" :src="shangjiList[7]"></td>
                </tr>
                <tr>
                  <td>酒店与度假村</td>
                </tr>
                <tr>
                  <td>旅客在住宿期间可以为车辆充电，确保离开时车辆电量充足</td>
                </tr>
              </table>
            </li>
          </ul>

        </div>
      </div>
    </div>
    <!-- 自助运营 -->
    <div v-if="show2" class="zizhu">
      <div :class="{ 'commit-tit': true, 'fadeInUp': zizhuTitle }" id="zizhuTitle">
        <h3>自助运营、一键收款、被动收入</h3>
      </div>
      <div :class="{ 'zizhu-content': true }" id="zizhuContent" style="height:253px">
        <img :class="{ 'fadeInRight': zizhuContent }" :src="zizhu" style="width:100%" />
      </div>
    </div>
    <!-- 招商加盟 -->
    <div class="strip">
      <div class="zhaoshang">
        <div :class="{ 'commit-tit': true, 'fadeInUp': zhaoshangTitle }" id="zhaoshangTitle">
          <h3>招商加盟</h3>
        </div>
        <div :class="{ 'zhaoshang-content': true }" id="zhaoshangContent" style="height:315px">
          <img :class="{ 'fadeInRight': zhaoshangContent }" :src="zhaoshang" style="width:100%" />
        </div>
      </div>
    </div>
    <!-- 期待与您的合作 -->
    <div v-if="show2" class="hezuo">
      <div :class="{ 'commit-tit': true, 'fadeInUp': hezuoTitle }" id="hezuoTitle">
        <h3>期待与您的合作</h3>
      </div>
      <div :class="{ 'hezuo-content': true }" id="hezuoContent">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="联系人" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入联系人的姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input type="text" v-model="ruleForm.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
          <el-form-item label="地区" prop="address">
            <el-input v-model="ruleForm.address" placeholder="请输入地区"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-if="show2" class="chengyao">
      <div :class="{ 'commit-tit': true, 'fadeInUp': chengyaoTitle }" id="chengyaoTitle">
        <h3>诚邀志同道合伙伴，共创新能源辉煌条件</h3>
      </div>
      <div :class="{ 'chengyao-content': true }" id="chengyaoContent">
        <table>
          <tr>
            <td>
              <p class="title">1.高度认同行业发展</p>
              <p>认同新能源行业的前景，准确把握地区发展脉搏，长期致力于此领域的投入与成长。</p>
            </td>
            <td>
              <p class="title">2.具备良好的商业信誉</p>
              <p>具备良好的商业道德和诚信记录，无不良商业行为历史。</p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="title">3.场地资源优势</p>
              <p>拥有或能有效开发地方社区、物业管理等关键场地资源，展现强大的地方影响力与资源整合优势。</p>
            </td>
            <td>
              <p class="title">4.学习与成长意愿</p>
              <p>积极参加总部提供的各类培训，不断提升自身及团队的专业技能与管理水平。</p>
            </td>
          </tr>
          <tr>
            <td>
              <p class="title">5.服务意识</p>
              <p>强烈的服务意识，致力于提升客户体验，能够快速响应并解决用户反馈的问题。</p>
            </td>
            <td>
              <p class="title">6.长远发展规划</p>
              <p>有明确的业务发展计划与愿景，愿意与【充否】建立长期合作关系，共谋长远发展。</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 服务支持 -->
    <div v-if="show2" class="strip">
      <div class="commmon-padding fuwu">

        <div :class="{ 'commit-tit': true, 'fadeInUp': fuwuTitle }" id="fuwuTitle">
          <h3>服务支持</h3>
        </div>

        <div class="" id="fuwuContent">
          <div :class="{ 'fadeInLeft': fuwuContent, 'left': true }" id="fuwuContent1">
            <div style="background: #fff;  padding:20px;padding-bottom:0px ">
              <el-carousel :interval="4000" indicator-position="outside">
                <el-carousel-item v-for="item in list" :key="item">
                  <el-image style="width: 100%; height: auto" :src="item"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div :class="{ 'introduct': true, 'fadeInRight': fuwuContent, 'right': true }" id="fuwuContent2">
            <ul class="right-img">
              <li v-for="(item, index) in fuwuList" :key="index">
                <el-image :src="item"></el-image>
              </li>
            </ul>
          </div>

        </div>
      </div>
      <div class="content2" id="content2">
        <ul :class="{ 'fadeInUp': content2_animation }">
          <li data-name="name1" :class="{ active: activeName == 'name1' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name1'">
              <tr>
                <td> <img class="img" :src="fuwuList2[0]"></td>
              </tr>
              <tr>
                <td>专业业务培训</td>
              </tr>
            </table>
            <p v-if="activeName == 'name1'">
              涵盖市场分析、业务策略等，确保合作伙伴深刻理解行业，快速上手业务。
            </p>
          </li>

          <li data-name="name2" :class="{ active: activeName == 'name2' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name2'">
              <tr>
                <td> <img class="img" :src="fuwuList2[1]"></td>
              </tr>
              <tr>
                <td>系统操作精讲</td>
              </tr>
            </table>
            <p v-if="activeName == 'name2'">
              深入讲解平台使用，包括后台管理、数据分析等，让运营更专业。
            </p>
          </li>
          <li data-name="name3" :class="{ active: activeName == 'name3' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name3'">
              <tr>
                <td> <img class="img" :src="fuwuList2[2]"></td>
              </tr>
              <tr>
                <td>物业合作指导</td>
              </tr>
            </table>
            <p v-if="activeName == 'name3'">
              传授物业公关与谈判技巧，助力顺利推进站点布局与合作洽谈。
            </p>
          </li>
          <li data-name="name4" :class="{ active: activeName == 'name4' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name4'">
              <tr>
                <td> <img class="img" :src="fuwuList2[3]"></td>
              </tr>
              <tr>
                <td> 营销实战培训</td>
              </tr>
            </table>
            <p v-if="activeName == 'name4'">
              教授多渠道推广技巧，包括线上推广、地推策略，提升市场渗透力。
            </p>
          </li>
          <li data-name="name5" :class="{ active: activeName == 'name5' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name5'">
              <tr>
                <td> <img class="img" :src="fuwuList2[4]"></td>
              </tr>
              <tr>
                <td>宣传物资礼包</td>
              </tr>
            </table>
            <p v-if="activeName == 'name5'">
              提供定制宣传材料，如海报、手册等，增强品牌曝光与吸引客户。
            </p>
          </li>
        </ul>
        <ul :class="{ 'fadeInUp': content2_animation }">
          <li data-name="name6" :class="{ active: activeName == 'name6' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name6'">
              <tr>
                <td> <img class="img" :src="fuwuList2[5]"></td>
              </tr>
              <tr>
                <td>全天候技术援助</td>
              </tr>
            </table>
            <p v-if="activeName == 'name6'">
              设立专业技术团队，随时解答产品疑问，保障设备稳定运行。
            </p>
          </li>

          <li data-name="name7" :class="{ active: activeName == 'name7' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name7'">
              <tr>
                <td> <img class="img" :src="fuwuList2[6]"></td>
              </tr>
              <tr>
                <td>健全售后体系</td>
              </tr>
            </table>
            <p v-if="activeName == 'name7'">
              构建全国售后服务网络，快速响应客户需求，维护良好用户体验。
            </p>
          </li>
          <li data-name="name8" :class="{ active: activeName == 'name8' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name8'">
              <tr>
                <td> <img class="img" :src="fuwuList2[7]"></td>
              </tr>
              <tr>
                <td>长短期套餐设计</td>
              </tr>
            </table>
            <p v-if="activeName == 'name8'">
              提供优惠券/满减等多样化计费方案，增加用户粘性，稳定收入来源。
            </p>
          </li>
          <li data-name="name9" :class="{ active: activeName == 'name9' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name9'">
              <tr>
                <td> <img class="img" :src="fuwuList2[8]"></td>
              </tr>
              <tr>
                <td> 社群与线下联动</td>
              </tr>
            </table>
            <p v-if="activeName == 'name9'">
              指导建立微信社群，组织线下活动，构建用户社区，深化品牌忠诚度。
            </p>
          </li>
          <li data-name="name10" :class="{ active: activeName == 'name10' }" @mouseenter="mouseEnter" @mouseleave="mouseOut">
            <table v-show="activeName != 'name10'">
              <tr>
                <td> <img class="img" :src="fuwuList2[9]"></td>
              </tr>
              <tr>
                <td>日常运营指导</td>
              </tr>
            </table>
            <p v-if="activeName == 'name10'">
              提升日常运营效率与效果，确保业务平稳运行并实现长期发展。
            </p>
          </li>
        </ul>
        <!-- <p class="intr">全程扶持 — 贴心陪伴 共创每一步辉煌精心打造的十二项扶持政策，全方位保障合作伙伴顺利启航，创业路上无忧前行：每一项扶持政策都是为了确保合作伙伴能够轻松跨越行业门槛，高效启动并持续发展业务，实现创业梦想与财富增长的双重飞跃。</p> -->
      </div>
    </div>

    <!-- 关于我们 -->
    <div v-if="show3" class="introduce" id="introduce">
      <div :class="{ 'commit-tit': true, 'fadeInUp': introduceTitle }" id="introduceTitle">
        <h3>关于我们</h3>
      </div>
      <div :class="{ 'introduce-content': true, 'fadeInUp': introduceContent }" id="introduceContent">
        <p style="color:#7d7d7d;line-height:30px">
          在新能源汽车产业蓬勃兴起的时代背景下，【充否】以行业先行者的姿态傲视群雄，依托坚实的自主研发能力和多年的自持运营场站实战积累，成就了月均交易电量破千万度的辉煌业绩。作为充电领域的佼佼者，【充否】深耕技术创新，不仅在软件与硬件层面持续突破，更凭借一套成熟完善的运营体系和一支资历深厚的专家团队，为客户提供全方位的服务。
        </p>
        <img :src="introduce" style="width:100%;height: auto;" />
      </div>
      <div>
        <ul>
          <li v-for="(item,index) in aboutImgs" :key="index">
            <img :src="item" />
          </li>
        </ul>
      </div>
    </div>
    <!-- 荣誉资质 -->
    <div v-if="show3" class="honors">
      <div :class="{ 'commit-tit': true, 'fadeInUp': honorsTitle }" id="honorsTitle">
        <h3>荣誉资质</h3>
      </div>
      <div :class="{ 'introduce-content': true, 'fadeInLeft': honorsContent }" id="picList">

        <el-carousel indicator-position="outside">
          <el-carousel-item>
            <template v-for="(item,index) in picArr1" >
              <el-image  v-if="index<5" :src="item" :key="item"></el-image>
            </template>
          </el-carousel-item>
          <el-carousel-item>
            <template v-for="(item,index) in picArr1" >
              <el-image  v-if="index<10&&index>4" :src="item" :key="item"></el-image>
            </template>
          </el-carousel-item>
          <el-carousel-item>
            <el-image style="width:47%;margin-top:0;height:270px" :src="picArr1[10]"></el-image>
            <el-image style="width:47%;margin-top:0;" :src="picArr1[11]"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 合作伙伴 -->
    <div v-if="show3" class="partners">
      <div :class="{ 'commit-tit': true, 'fadeInDown': partnersTitle }" id="partnersTitle">
        <h3>合作伙伴</h3>
      </div>
      <div :class="{ 'introduce-content': true, 'fadeInDown': partnersContent }" id="partnersList">
        <el-carousel indicator-position="outside">
          <el-carousel-item>
            <ul>
              <li v-for="item in partners1" :key="item">
                <img :src='"@/assets/img/huoban/"+item+".png"' alt="" />
              </li>
            </ul>
          </el-carousel-item>
          <el-carousel-item>
            <ul>
              <li v-for="item in partners2" :key="item">
                <img :src='"@/assets/img/huoban/"+item+".png"' alt="" />
              </li>
              <li><img src="" /></li>
              <li><img src="" /></li>
            </ul>
          </el-carousel-item>
        </el-carousel>

      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../assets/bus.js';//引入中央总线Vue实例
import axios from 'axios';
export default {
  name: 'Home',
  components: {
  },
  data() {
    let validNum = (rule, value, callback) => {
      if (value.length != 11) {
        callback(new Error("请输入11位数字"));
      }
      if (/^\d+$/.test(value)) {
        callback();
      } else {
        callback(new Error("请输入数字"));
      }

    };
    return {
      partners1:[1,2,3,'jj',5,6,7,8,9,10,11,12,13,14,15],
      partners2:[16,17,18,19,20,21,22,23,24,25,26,27,28],
      bannerUrl: require("@/assets/img/banner.png"),
      gl: require("@/assets/img/cp.png"),
      gou: require("@/assets/img/gou.png"),

      zixun: require("@/assets/img/zixun.png"),
      zizhu: require("@/assets/img/zizhu.png"),
      zhaoshang: require("@/assets/img/zhaoshang.png"),
      introduce: require("@/assets/img/introduce.png"),
      show2: false,
      show3: false,
      showbanner: false,
      product: false,
      aboutUs: false,
      jiaodai_animation: false,
      introduceTitle: false,
      introduceContent: false,
      honorsTitle: false,
      honorsContent: false,
      partnersTitle: false,
      partnersContent: false,
      content2_animation: false,
      shangjiTitle: false,
      shangjiContent: false,
      zizhuTitle: false,
      zizhuContent: false,
      zhaoshangTitle: false,
      zhaoshangContent: false,
      chengyaoTitle: false,
      chengyaoContent: false,
      hezuoTitle: false,
      hezuoContent: false,

      fuwuTitle: false,
      fuwuContent: false,

      picArr: [
        { url: require("@/assets/img/h1.png"), url2: require("@/assets/img/h1_x2.png"), left: 0, scale: 0.6 },
        { url: require("@/assets/img/h2.png"), url2: require("@/assets/img/h2_x2.png"), left: 0, scale: 0.8 },
        { url: require("@/assets/img/h3.png"), url2: require("@/assets/img/h3_x2.png"), left: 0, scale: 1 },
        { url: require("@/assets/img/h4.png"), url2: require("@/assets/img/h4_x2.png"), left: 0, scale: 0.8 },
        { url: require("@/assets/img/h5.png"), url2: require("@/assets/img/h5_x2.png"), left: 0, scale: 0.6 },
      ],
      picArr1: [
        require("@/assets/img/hor/h1.jpg"),
        require("@/assets/img/hor/h2.jpg"),
        require("@/assets/img/hor/h3.jpg"),
        require("@/assets/img/hor/h4.jpg"),
        require("@/assets/img/hor/h5.jpg"),
        require("@/assets/img/hor/h6.jpg"),
        require("@/assets/img/hor/h7.jpg"),
        require("@/assets/img/hor/h8.jpg"),
        require("@/assets/img/hor/h9.jpg"),
        require("@/assets/img/hor/h10.jpg"),
        require("@/assets/img/hor/h11.jpg"),
        require("@/assets/img/hor/h12.jpg")
      ],
      partnersList: [
        { url: require("@/assets/img/p1.png") },
        { url: require("@/assets/img/p2.png") },
        { url: require("@/assets/img/p3.png") },
        { url: require("@/assets/img/p4.png") },
        { url: require("@/assets/img/p5.png") },
      ],
      tipIndex: 1,                 // 0-4 用于更新底部圆点  共 5个真实 li
      isChanging: false,           // 是否正在变换
      userChanging: false,         // 是否是用户触发的变换
      activeName: '',
      list: [
        require("@/assets/img/fuwu/1.png"),
        require("@/assets/img/fuwu/2.png"),
        require("@/assets/img/fuwu/3.png")
      ],
      fuwuList: [
        require("@/assets/img/f1.png"),
        require("@/assets/img/f2.png"),
        require("@/assets/img/f3.png"),
        require("@/assets/img/f4.png"),
        require("@/assets/img/f5.png"),
        require("@/assets/img/f6.png")
      ],
      fuwuList2: [
        require("@/assets/img/fa.png"),
        require("@/assets/img/fb.png"),
        require("@/assets/img/fc.png"),
        require("@/assets/img/fd.png"),
        require("@/assets/img/fe.png"),
        require("@/assets/img/ff.png"),
        require("@/assets/img/fg.png"),
        require("@/assets/img/fh.png"),
        require("@/assets/img/fi.png"),
        require("@/assets/img/fj.png")
      ],
      aboutImgs: [
        require("@/assets/img/a1.png"),
        require("@/assets/img/a2.png"),
        require("@/assets/img/a3.png"),
        require("@/assets/img/a4.png")
      ],
      shangjiList: [
        require("@/assets/img/shangji/1.png"),
        require("@/assets/img/shangji/2.png"),
        require("@/assets/img/shangji/3.png"),
        require("@/assets/img/shangji/4.png"),
        require("@/assets/img/shangji/5.png"),
        require("@/assets/img/shangji/6.png"),
        require("@/assets/img/shangji/7.png"),
        require("@/assets/img/shangji/8.png")

      ],
      ruleForm: {
        name: '',
        address: '',
        phone: ''
      },

      rules: {
        name: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          { validator: validNum, trigger: "blur" },
        ],
        address: [
          { required: true, message: '请输入地区', trigger: 'blur' }
        ],
      }
    }
  },
  created() {

  },
  mounted() {
    bus.$on("scrollGo", (data) => {
      this.show2 = true;
      if (data.name == 'introduce') {
        this.show3 = true;
      }
      this.$nextTick(() => {
        if (data.name) {
          let offset = document.getElementById(data.name).offsetTop;
          window.scrollTo({ top: offset - 100, behavior: 'smooth' })
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        }
      })

    })
    this.$nextTick(() => {
      window.addEventListener('scroll', () => {
        this.show2 = true;
        if (document.documentElement.scrollTop > 4500) {
          this.show3 = true;
        }
      })
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          axios.get('https://bjthinkpower.com/station2/consult/add?name=' + this.ruleForm.name +
            '&phone=' + this.ruleForm.phone + '&address=' + this.ruleForm.address)
            .then(result => {
              var res = result.data;
              console.log(res)
              if (res.code == 0) {
                this.$message({
                  message: '提交成功!',
                  type: 'success'
                });
                this.ruleForm.name = '';
                this.ruleForm.phone = '';
                this.ruleForm.address = '';
              } else {
                this.$message({
                  message: '提交失败!',
                  type: 'error'
                });
              }
            })
            .catch(error => {
              this.$message({
                message: '提交失败!',
                type: 'error'
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    gotoJiameng() {
      let offset = document.getElementById('hezuoTitle').offsetTop;
      window.scrollTo({ top: offset - 100, behavior: 'smooth' })
    },
    mouseEnter(item) {
      this.activeName = item.target.dataset.name;
    }
    ,
    mouseOut() {
      this.activeName = ''
    }
  },
}
</script>

<style scoped lang="less">
.fadeInLeft {
  animation: fadeInLeft 1s;
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
}
.fadeInRight {
  animation: fadeInRight 1s;
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
}
.fadeInUp {
  animation: fadeInUp 1s;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
.fadeInDown {
  animation: fadeInDown 1s;
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
}

.fixd {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: space-Between;
  -webkit-justify-content: space-Between;
  -moz-box-pack: space-Between;
  -ms-flex-pack: space-Between;
  justify-content: space-Between;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

.banner {
  a {
    &:hover:after {
      border-bottom: none;
    }
    &:hover {
      color: #1e5ef0;
      scale: 1.2;
    }
    text-align: center;
    font-weight: 800;
    font-size: 19px;
    height: 50px;
    color: #1e5ef0;
    padding: 10px 0px;
    background: #fff;
    border-radius: 40px;
    width: 180px;
    position: absolute;
    top: calc(29vw);
    left: calc(15.2vw);
    cursor: pointer;
    img {
      margin-right: 6px;
      height: 30px;
      vertical-align: text-top;
    }
  }
}

.product-serve {
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 43px;
  padding-bottom: 43px;

  h2 {
    font-size: 32px;
    line-height: 1.4;
    color: #333;
    font-weight: bold;
  }

  .small-text {
    font-size: 20px;
    line-height: 1.4;
    color: #999999;
    margin-top: 10px;
  }
}

.jiaodai,
.shangji {
  padding-bottom: 60px;
  .fixd();
  align-items: center;

  .introduct {
    width: 47%;

    .commit-tit {
      text-align: left;

      h3 {
        font-size: 28px;
        line-height: 1.4;
      }

      .small-text {
        font-size: 16px;
      }
    }

    .img-parent {
      width: 41%;
    }

    .text {
      font-size: 14px;
      line-height: 24px;
      color: #666;
      margin-top: 25px;
      text-align: justify;
    }
  }

  .img-parent {
    width: 49%;
  }
}

.solution,
.shangji,
.introduce,
.honors,
.zizhu,
.hezuo,
.chengyao,
.zhaoshang,
.fuwu,
.partners {
  padding-top: 60px;
  padding-bottom: 60px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .commit-tit {
    text-align: center;

    h3 {
      font-size: 36px;
      line-height: 1.4;
      font-weight: bold;
      font-family: "Oswald-DemiBold";
    }

    .small-text {
      font-size: 20px;
      line-height: 1.4;
      color: #999999;
      margin-top: 10px;
    }
  }
  .introduce-content,
  #fuwuContent {
    font-size: 14px;
    line-height: 24px;
    color: #666;
    margin-top: 25px;
    text-align: justify;

    p {
      margin-bottom: 23px;
    }
  }
}

/deep/.honors {
  .el-carousel__container {
    height: 300px;
    margin-bottom: 26px;
  }
  background: url("~@/assets/img/honors2.png") no-repeat;
  background-position-x: center;
  padding-bottom:20px;
  background-size: 100% 100%;

  #picList {
    width: 1000px;
    overflow: hidden;
  }
  .el-carousel__item {
    display: flex;
    justify-content: space-between;
  }
  .el-image {
    width: 19%;

    &:first-child,
    &:nth-child(5) {
      margin-top: 60px;
      height: 240px;
    }
    &:nth-child(2),
    &:nth-child(4) {
      margin-top: 30px;
      height: 270px;
    }
  }
}

.partners {
  /deep/.el-carousel__container {
    height: 400px;
  }
  #partnersList {
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      li {
        width: 20%;
        &:hover {
          scale: 1.1;
        }
      }
    }
  }
}
/deep/.partners,
/deep/.honors {
  img {
    cursor: inherit;
  }
}
#fuwuContent {
  width: 100%;
  margin-bottom: 0px;
  .fixd();

  ul {
    height: 300px;
    li {
      line-height: 26px;
    }
  }

  p.title {
    font-size: 24px;
    font-weight: bold;
    color: #2997ea;
    line-height: 33px;
    text-align: left;
    margin-bottom: 0;
  }

  .left {
    width: 53%;
  }

  .right {
    width: 42%;
  }
}
.content4 {
  padding-bottom: 0 !important;
}
/deep/#fuwuContent {
  .el-carousel__button {
    background-color: #e7ecf3;
    opacity: 1;
  }

  .is-active {
    .el-carousel__button {
      background-color: #1e5ef0;
    }
  }
  .right-img {
    padding-top: 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      display: flex;
      width: 28%;
      .el-image {
        margin: auto;
      }
      img {
        height: 120px;
      }
    }
  }
}
/deep/.el-carousel__container {
  height: 260px;
}
.content4 {
  /deep/.el-carousel__container {
    height: 270px;
  }
}

#introduce {
  ul {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    li {
      width: 23%;
      img {
        width: 100%;
        &:hover {
          scale: 1.1;
        }
      }
    }
  }
}
.fuwu {
  padding-bottom: 20px;
}
.content2 {
  padding-bottom: 60px;
  ul {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    li {
      cursor: pointer;
      background: #fff;
      font-size: 14px;
      color: #666666;
      height: 160px;
      padding: 20px 0px;
      width: 18%;
      border-radius: 8px;
      transition: 1s;
      transform-style: preserve-3d; /* 让其有3d效果 */
      img {
        height: 50px;
      }
      table {
        backface-visibility: hidden; /*翻转隐藏背面 */
        width: 100%;

        td {
          text-align: center;
          font-size: 16px;
          padding: 10px;
          color: #333333;
        }
      }
      p {
        padding: 0px 20px;
          line-height: 28px;
        transform: rotateY(180deg);
        backface-visibility: hidden; /*翻转隐藏背面 */
      }
      &.active {
        transform: rotateY(180deg);
      }
    }
  }

  p.intr {
    line-height: 30px;
    color: #333333;
  }
}
/deep/.el-carousel__indicator button {
  background: #000;
}
/deep/.el-carousel__indicator.is-active button {
  background: #1e5ef0;
}
.jiaodai {
  align-items: flex-start;
  h3 {
    font-size: 3.7rem;
    color: #333333;
    margin-bottom: 3rem;
  }
  .text1 {
    font-size: 1.6rem;
    color: #666666;
    margin-bottom: 20px;
  }
  .text2 {
    color: #333333;
    font-size: 20px;
    margin-bottom: 20px;
    img {
      width: 24px;
      vertical-align: middle;
      margin-right: 6px;
    }
  }
  .text3 {
    font-size: 1.6rem;
    color: #9ea5bb;
  }
  .introduct {
    height: 658px;
    background: url("~@/assets/img/cpbg.png") no-repeat;
    background-size: 100% auto;
    background-position-y: bottom;
    padding: 30px 30px;
  }
  img {
    width: 100%;
  }
}
.shangji {
  ul {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    li {
      padding: 20px;
      background: #fff;
      width: calc((100% - 30px) / 4);
      text-align: center;
      margin-bottom: 10px;
      table {
        td {
          padding: 10px;
        }
        tr:nth-child(1) {
          td {
            img {
              height: 54px;
            }
          }
        }
        tr:nth-child(2) {
          td {
            font-size: 18px;
            color: #333333;
          }
        }
        tr:nth-child(3) {
          td {
            font-size: 15px;
            color: #7d7d7d;
          }
        }
      }
    }
  }
}

/deep/#hezuoContent {
  .el-form-item__label {
    width: 100% !important;
    text-align: left;
    font-size: 19px;
    color: #333;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    margin-bottom: 20px;
  }
  .el-form-item__content {
    margin-left: 0 !important;
    .el-input__inner {
      border: none;
      background: #f5f5f7;
      height: 40px;
      line-height: 40px;
    }
  }
  button {
    font-size: 18px;
    width: 100%;
    height: 50px;
    background: #1e5ef0;
  }
}
#chengyaoContent {
  height: 400px;
  color: #7d7d7d;
  table {
    height: 100%;
    td {
      font-size: 15px;
      width: 50%;
      padding-right: 40px;
    }
    td:first-child {
      border-right: 1px solid #dfdfdf;
    }
    td:last-child {
      padding-left: 30px;
    }
    tr:nth-child(2) {
      td {
        border-top: 1px solid #dfdfdf;
        border-bottom: 1px solid #dfdfdf;
      }
      td:last-child {
        border-right: none;
      }
    }
    .title {
      font-size: 17px;
      font-weight: bold;
      height: 40px;
      color: #333333;
    }
  }
}
.chengyao {
  padding-top: 0;
}
#zizhuContent,
#zhaoshangContent,
#chengyaoContent,
#hezuoContent,
.content2,
#introduce,
.introduce-content,
#fuwuContent,
.jiaodai,
.shangji {
  width: 1000px;
  margin: 0 auto;
}

#shangjiTitle,
#zizhuTitle,
#zhaoshangTitle,
#chengyaoTitle,
#hezuoTitle,
#fuwuTitle {
  width: 100%;
  h3 {
    width: 100%;
    text-align: center;
    margin-bottom: 40px;
  }
}
/deep/ .el-backtop {
  width: 100px;
  height: 100px;
  border-radius: 0;
  box-shadow: none;
  background: transparent;
}
@media screen and(max-height:1200px) {
  .banner {
    a {
      //top: calc(53vh);
      &:hover {
        scale: 1.1;
      }
    }
  }
}
@media screen and(max-height:1000px) {
  .banner {
    a {
      //top: calc(66vh);
      &:hover {
        scale: 1.1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/home.vue